import { render, staticRenderFns } from "./ArchivedTask.vue?vue&type=template&id=023d6fe7&"
import script from "./ArchivedTask.vue?vue&type=script&lang=js&"
export * from "./ArchivedTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports